import ColorPicker from 'vue-color-kit'
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ColorPicker)
})